import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth, selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import {
  fetchMetaBilling,
  selectMetaLoaded,
  setMetaBilling,
} from "../redux/reducers/metaBilling.reducer";
import {
  startLoadingExternalBilling,
  setIsLoadingExternalBilling,
} from "../../ProductsModule/redux/reducers/products.reducer";

/**
 * Idempotent hook — loads Billing metadata (users, invoice owners, work orders,
 * billing cycles, projects, clients) exactly once per session.
 *
 * Also drives the isLoadingExternalBilling flag in the Products reducer so that
 * ProductsListPage and ClientKeyContactDetailPage show correct loading states.
 *
 * Safe to call from multiple components (InvoiceQuery, RecurringQuery,
 * ProfessionalServicesQuery, ClientKeyContactDetailPage).
 * Auth guard is included because Billing routes have no isAuthenticated wrapper
 * in the router.
 */
export const useBillingMetadata = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(selectAuth);
  const { rolesLoaded } = useSelector(selectUserRoles);
  const metaLoaded = useSelector(selectMetaLoaded);

  useEffect(() => {
    if (!isAuthenticated || !rolesLoaded || metaLoaded) return;

    (async () => {
      dispatch(startLoadingExternalBilling());
      const metaBilling = await fetchMetaBilling();
      localStorage.setItem("metaBillingUsers", JSON.stringify(metaBilling.users));
      dispatch(setMetaBilling(metaBilling));
      dispatch(setIsLoadingExternalBilling(false));
    })();
  }, [isAuthenticated, rolesLoaded, metaLoaded]); // eslint-disable-line react-hooks/exhaustive-deps
};
